export default {
      id: "i-view-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-view",
      toString: function () {
        return this.url;
      }
    }